import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardQuestion, faLocationDot, faCloudBolt, faWater } from '@fortawesome/pro-solid-svg-icons';

const topics = [
  {
    icon: faClipboardQuestion,
    title: 'Nautical Knowledge Self Test',
    to: '/',
    desc: 'Interactive flip card-based testing platform covering multiple essential maritime topics required for Marine Master oral examinations. The system provides visual and text-based questions across diverse nautical knowledge categories.',
  },
  {
    icon: faLocationDot,
    title: 'IALA Buoyage System Region A',
    to: '/iala-buoyage-system-region-a',
    desc: 'Comprehensive training module on the International Association of Marine Aids to Navigation and Lighthouse Authorities (IALA) buoyage system, specifically Region A which covers Australia. The module provides detailed instruction on all navigation mark types used in Australian waters and provides a progress check tool useful for preparing for Oral Exams.',
  },
  {
    icon: faCloudBolt,
    title: 'Weather Observation Codes',
    to: '/weather-observation-codes',
    desc: 'Comprehensive reference guide and interactive training module for standardized weather observation coding systems used in maritime logbook entries and radio communications. Teaches mariners how to accurately record and communicate weather, sea, and visibility conditions using international standards.',
  },
  {
    icon: faWater,
    title: 'Tides',
    to: '/tides',
    desc: 'Understand tidal definitions, read standard port tables, calculate tides at secondary ports, and apply Under-Keel Clearance calculations using the Queensland Tide Tables.',
  },
];

export default function MarineMasterTrainingTopics() {
  return (
    <section className="as-section">
      <div className="container">
        <h1 className="as-page-title text-center">Marine Master Training Topics</h1>
        <p className="as-lead mx-auto text-center mb-5" style={{ maxWidth: 720 }}>
          Allships.com.au is a Marine Master Training platform providing comprehensive
          preparation materials for aspiring marine skippers pursuing their master tickets
          in Australia. The site focuses on practical, exam-ready content with interactive
          testing tools.
        </p>

        <div className="row g-4">
          {topics.map((topic) => (
            <div className="col-md-6" key={topic.title}>
              <Link to={topic.to} className="as-topic-card">
                <div className="as-topic-icon">
                  <FontAwesomeIcon icon={topic.icon} />
                </div>
                <h3>{topic.title}</h3>
                <p>{topic.desc}</p>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
